export enum AllowedBRNavRoutes {
  Insured = '/br-ucm-forms/br-insured',
  Owner = '/br-ucm-forms/br-owner',
  Jobsite = '/br-ucm-forms/br-jobsite',
  Liability = '/br-ucm-forms/br-liability',
  AdditionalInfo = '/br-ucm-forms/br-additionalinfo',
  GeneralQuestion = '/br-ucm-forms/br-generalquestion',
  Document = '/builders/underwriting/documents',
  RenewalReview = '/br-ucm-forms/br-renewalreview',
  Snapshot = '/builders/pending-review/policysnapshot',
  BRCoverage = '/builders/pending-review/verifycoverage',
  BRPolicy = '/builders/pending-review/verifypolicy',
  VPActionItems = '/builders/verify-purchase/actionitems',
  VPCoverage = '/builders/verify-purchase/coverages',
  VPPolicy = '/builders/verify-purchase/policy'
}

export enum AllowedBRBoundNavRoutes {
  PolicyInfo = '/bound',
  Coverage = '/bound',
  Snapshot = '/bound',
  Declined = '/declined'
}

export enum BRSubmissionRoutes {
  Step1A = AllowedBRNavRoutes.Insured,
  Step1Address = AllowedBRNavRoutes.Insured,
  Step1AUpdate = AllowedBRNavRoutes.Insured,
  // Step1B = AllowedBRNavRoutes.Owner,
  // Step1BUpdate = AllowedBRNavRoutes.Owner,
  // Step1C = AllowedBRNavRoutes.Jobsite,
  // Step1CUpdate = AllowedBRNavRoutes.Jobsite,
  Step1B = AllowedBRNavRoutes.Jobsite,
  Step1BUpdate = AllowedBRNavRoutes.Jobsite,
  Step2A = AllowedBRNavRoutes.Liability,
  Step2AUpdate = AllowedBRNavRoutes.Liability,
  Step2B = AllowedBRNavRoutes.AdditionalInfo,
  Step2BUpdate = AllowedBRNavRoutes.AdditionalInfo,
  Step3A = AllowedBRNavRoutes.GeneralQuestion,
  Step3AUpdate = AllowedBRNavRoutes.GeneralQuestion,
  Step3C = AllowedBRNavRoutes.Document,
  Step3CUpdate = AllowedBRNavRoutes.Document,
  Renewal = AllowedBRNavRoutes.RenewalReview,
  RenewalReview = AllowedBRNavRoutes.RenewalReview,
  Step4A = AllowedBRNavRoutes.VPActionItems,
  Step4CompForms = AllowedBRNavRoutes.VPActionItems,
  Step4DwnloadDoc = AllowedBRNavRoutes.VPActionItems,
  Step4InstBill = AllowedBRNavRoutes.VPActionItems,
  Step4InstPaid = AllowedBRNavRoutes.VPActionItems,
  Step4InsurForm = AllowedBRNavRoutes.VPActionItems,
  Step4NewTxn = AllowedBRNavRoutes.VPActionItems,
  Step4BRemFin = AllowedBRNavRoutes.VPActionItems,
  Step4Purchase = AllowedBRNavRoutes.VPActionItems,
  Step4Update = AllowedBRNavRoutes.VPActionItems,
  EHelpUWReview = AllowedBRNavRoutes.Snapshot,

  Declined = AllowedBRBoundNavRoutes.Declined,
  'Declined New Business' = AllowedBRBoundNavRoutes.Declined,
  EHelBReviewDoc = AllowedBRBoundNavRoutes.Snapshot,
  InspCreated = AllowedBRBoundNavRoutes.Snapshot,
  InspInfoRequest = AllowedBRBoundNavRoutes.Snapshot,
  InsBReview = AllowedBRBoundNavRoutes.Snapshot,
  PolicyBound = AllowedBRBoundNavRoutes.Snapshot,
  StepENAddChange = AllowedBRBoundNavRoutes.Snapshot,
  StepENAIChange = AllowedBRBoundNavRoutes.Snapshot,
  StepENExpChange = AllowedBRBoundNavRoutes.Snapshot,
  InspCompleted = AllowedBRBoundNavRoutes.Snapshot
}
